// extracted by mini-css-extract-plugin
export default {"img":"styles_img__JOpus","ft-fadeIn":"styles_ft-fadeIn__QCYcD","websearch":"styles_websearch__pGmMm","websearchIcon":"styles_websearchIcon__zdZiv"};